import React from 'react';
import { ChevronRight } from 'lucide-react';
import defaultHeroImg from '../assets/Banner-GMIS Students.png';

import { Link } from 'react-router-dom';

export default function PageHero({ eyebrow, title, subtitle, bgImage, breadcrumbs = [] }) {
  const imageToUse = bgImage || defaultHeroImg;

  return (
    <div className="relative w-full overflow-hidden bg-navy pt-16 lg:pt-[220px] pb-20 flex items-center min-h-[420px]">
      <div className="absolute inset-0">
        <img src={imageToUse} alt={typeof title === 'string' ? title : "Hero Background"} className="w-full h-full object-cover object-center opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/80 to-navy/30" />
      </div>
      <div className="relative z-10 max-w-[1200px] mx-auto px-8 w-full">
        {eyebrow && (
          <div className="inline-flex items-center gap-2 mb-5 px-4 py-1.5 rounded-full border border-gold/30 bg-gold/10">
            <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">{eyebrow}</span>
          </div>
        )}
        <h1 className="text-[2.8rem] w-[80%] font-heading font-bold text-white leading-[1.05] tracking-tight mb-4">
          {title}
        </h1>
        
        {subtitle && (
          <p className="text-white/70 text-[16px] max-w-xl leading-relaxed mt-2 mb-6">
            {subtitle}
          </p>
        )}
        
        {/* Breadcrumbs */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div className="flex flex-wrap items-center gap-2 text-[13px] font-bold tracking-widest text-white/60 uppercase">
            {(breadcrumbs.length > 2 ? [breadcrumbs[0], breadcrumbs[breadcrumbs.length - 1]] : breadcrumbs).map((crumb, idx, arr) => (
              <React.Fragment key={idx}>
                {crumb.toLowerCase() === 'home' ? (
                  <Link to="/" className="hover:text-white transition-colors">
                    {crumb}
                  </Link>
                ) : (
                  <span className={idx === arr.length - 1 ? "text-gold" : ""}>
                    {crumb}
                  </span>
                )}
                {idx < arr.length - 1 && <ChevronRight size={14} className="opacity-50" />}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
